var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c("div", { staticClass: "app-main-inner-row" }, [
          _c(
            "div",
            { staticClass: "filters" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "60px",
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.BusinessEntity")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              model: {
                                value: _vm.searchConditions.entityCode,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchConditions,
                                    "entityCode",
                                    $$v
                                  )
                                },
                                expression: "searchConditions.entityCode"
                              }
                            },
                            _vm._l(_vm.entitySelectOption, function(entity) {
                              return _c("el-option", {
                                key: entity.value,
                                attrs: {
                                  value: entity.value,
                                  label: entity.name
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      !_vm.isPlateForm
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SystemMaintenance.Branch")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  model: {
                                    value: _vm.searchConditions.branchId,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.searchConditions,
                                        "branchId",
                                        $$v
                                      )
                                    },
                                    expression: "searchConditions.branchId"
                                  }
                                },
                                _vm._l(_vm.currentOfficeList, function(office) {
                                  return _c("el-option", {
                                    key: office.uuid,
                                    attrs: {
                                      value: office.officeId,
                                      label: office.chineseName
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "triggers" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.fetchDefaultValueList }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.toAdd } },
                [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.toEdit } },
                [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "danger" }, on: { click: _vm.toBatchDel } },
                [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "warning" }, on: { click: _vm.reset } },
                [_vm._v(_vm._s(_vm.$t("common.btn.reset")))]
              )
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "config-module": "260304",
                "grid-params": _vm.gridParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.gridParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.gridParams = $event
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.addDialog.isShow,
            "close-on-click-modal": false,
            title: _vm.$t("SystemMaintenance.SelectEntityConfigurationItem"),
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.addDialog, "isShow", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "div",
                { staticClass: "filters" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: { "label-width": "80px", "label-position": "left" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SystemMaintenance.BranchOffice2")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  on: { change: _vm.changeAddDialogOffice },
                                  model: {
                                    value: _vm.addDialog.form.branchId,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.addDialog.form,
                                        "branchId",
                                        $$v
                                      )
                                    },
                                    expression: "addDialog.form.branchId"
                                  }
                                },
                                _vm._l(_vm.currentOfficeList, function(office) {
                                  return _c("el-option", {
                                    key: office.uuid,
                                    attrs: {
                                      value: office.officeId,
                                      label: office.chineseName
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SystemMaintenance.EntitySelection"
                                )
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "row-grid-dialog",
                                  staticStyle: { width: "600px" }
                                },
                                [
                                  _c("cargo-ag-grid", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      "show-side-bar": false,
                                      "grid-params": _vm.addDialog.gridParams,
                                      "grid-options": _vm.addDialog.gridOptions,
                                      "column-defs": _vm.addDialogColumnDefs,
                                      "row-data": _vm.addDialog.rowData
                                    },
                                    on: {
                                      "update:gridParams": function($event) {
                                        return _vm.$set(
                                          _vm.addDialog,
                                          "gridParams",
                                          $event
                                        )
                                      },
                                      "update:grid-params": function($event) {
                                        return _vm.$set(
                                          _vm.addDialog,
                                          "gridParams",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveAdd } },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")) + " ")]
              ),
              _c("el-button", { on: { click: _vm.cancelSave } }, [
                _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
              ])
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.isShow,
            "close-on-click-modal": false,
            width: "400px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "isShow", $event)
            }
          }
        },
        [
          _c(
            "span",
            {
              staticStyle: { "font-size": "18px" },
              attrs: { slot: "title" },
              slot: "title"
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("CargoMsg.Cargo_EditDefaultValue")) + " "
              ),
              _c(
                "el-tooltip",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editDialog.form.entityCode === "Job",
                      expression: "editDialog.form.entityCode === 'Job'"
                    }
                  ],
                  attrs: {
                    content: _vm.$t("CargoMsg.Cargo_EditJobDefaultValueTip"),
                    placement: "top"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        border: "1px solid #AAAAAA",
                        "border-radius": "50%",
                        padding: "0 3px",
                        "font-size": "12px",
                        color: "#AAAAAA"
                      }
                    },
                    [_vm._v("?")]
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "app-main-inner-row" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "80px",
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "SystemMaintenance.AffiliatedBranchOffice"
                            )
                          },
                          model: {
                            value: _vm.editDialog.form,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog, "form", $$v)
                            },
                            expression: "editDialog.form"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.editDialog.form.officeCnName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "officeCnName",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.officeCnName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.EntityCode")
                          },
                          model: {
                            value: _vm.editDialog.form,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog, "form", $$v)
                            },
                            expression: "editDialog.form"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.canEdit },
                            model: {
                              value: _vm.editDialog.form.entityCode,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "entityCode", $$v)
                              },
                              expression: "editDialog.form.entityCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.EntityName")
                          },
                          model: {
                            value: _vm.editDialog.form,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog, "form", $$v)
                            },
                            expression: "editDialog.form"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.canEdit },
                            model: {
                              value: _vm.editDialog.form.entityName,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "entityName", $$v)
                              },
                              expression: "editDialog.form.entityName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.FieldCode")
                          },
                          model: {
                            value: _vm.editDialog.form,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog, "form", $$v)
                            },
                            expression: "editDialog.form"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.canEdit },
                            model: {
                              value: _vm.editDialog.form.fieldCode,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "fieldCode", $$v)
                              },
                              expression: "editDialog.form.fieldCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.FieldName")
                          },
                          model: {
                            value: _vm.editDialog.form,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog, "form", $$v)
                            },
                            expression: "editDialog.form"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.canEdit },
                            model: {
                              value: _vm.editDialog.form.fieldName,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "fieldName", $$v)
                              },
                              expression: "editDialog.form.fieldName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.ValueType")
                          },
                          model: {
                            value: _vm.editDialog.form,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog, "form", $$v)
                            },
                            expression: "editDialog.form"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.canEdit },
                            model: {
                              value: _vm.editDialog.form.valueType,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "valueType", $$v)
                              },
                              expression: "editDialog.form.valueType"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_DefaultValue")
                          },
                          model: {
                            value: _vm.editDialog.form,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog, "form", $$v)
                            },
                            expression: "editDialog.form"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: _vm.needTextareaField.includes(
                                _vm.editDialog.form.fieldCode
                              )
                                ? "textarea"
                                : "text"
                            },
                            model: {
                              value: _vm.editDialog.form.defaultValue,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "defaultValue",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.defaultValue"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.editDialog.form.entityCode === "Job",
                              expression: "editDialog.form.entityCode === 'Job'"
                            }
                          ]
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_SeDefaultValue")
                              },
                              model: {
                                value: _vm.editDialog.form,
                                callback: function($$v) {
                                  _vm.$set(_vm.editDialog, "form", $$v)
                                },
                                expression: "editDialog.form"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.editDialog.form.seDefaultValue,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "seDefaultValue",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.seDefaultValue"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_SiDefaultValue")
                              },
                              model: {
                                value: _vm.editDialog.form,
                                callback: function($$v) {
                                  _vm.$set(_vm.editDialog, "form", $$v)
                                },
                                expression: "editDialog.form"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.editDialog.form.siDefaultValue,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "siDefaultValue",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.siDefaultValue"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_AeDfaultValue")
                              },
                              model: {
                                value: _vm.editDialog.form,
                                callback: function($$v) {
                                  _vm.$set(_vm.editDialog, "form", $$v)
                                },
                                expression: "editDialog.form"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.editDialog.form.aeDefaultValue,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "aeDefaultValue",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.aeDefaultValue"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_AiDfaultValue")
                              },
                              model: {
                                value: _vm.editDialog.form,
                                callback: function($$v) {
                                  _vm.$set(_vm.editDialog, "form", $$v)
                                },
                                expression: "editDialog.form"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.editDialog.form.aiDefaultValue,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "aiDefaultValue",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.aiDefaultValue"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_ReDfaultValue")
                              },
                              model: {
                                value: _vm.editDialog.form,
                                callback: function($$v) {
                                  _vm.$set(_vm.editDialog, "form", $$v)
                                },
                                expression: "editDialog.form"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.editDialog.form.reDefaultValue,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "reDefaultValue",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.reDefaultValue"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_RiDfaultValue")
                              },
                              model: {
                                value: _vm.editDialog.form,
                                callback: function($$v) {
                                  _vm.$set(_vm.editDialog, "form", $$v)
                                },
                                expression: "editDialog.form"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.editDialog.form.riDefaultValue,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "riDefaultValue",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.riDefaultValue"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveEdit } },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")) + " ")]
              ),
              _c("el-button", { on: { click: _vm.cancelEdit } }, [
                _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
              ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }